(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/video-analysis-player/assets/javascripts/video-analysis-player.js') >= 0) return;  svs.modules.push('/components/tipsen/video-analysis-player/assets/javascripts/video-analysis-player.js');
"use strict";


const {
  useCallback,
  useMemo
} = React;
const {
  useSelector,
  useDispatch
} = ReactRedux;
const {
  ReactIcon,
  ReactIconButton
} = svs.ui;
const {
  VisibilityWrapper
} = svs.components.lbUi.visibilityWrapper;
const {
  clx
} = svs.components.lbUtils;
const {
  VideoPlayer
} = svs.components.video_player;
const {
  selectCurrentVideo
} = svs.components.tipsen.store.reducers.videoAnalysesSlice.selectors;
const {
  clearCurrentVideo,
  updatePlaybackState
} = svs.components.tipsen.store.reducers.videoAnalysesSlice.actions;
const {
  createInitialPlaybackState,
  useVideoLoader,
  usePlayerPolling
} = svs.components.tipsen.videoAnalysisPlayer;

const VideoAnalysisPlayer = _ref => {
  let {
    easeInOut = false
  } = _ref;
  const dispatch = useDispatch();
  const currentVideo = useSelector(selectCurrentVideo);

  const {
    loadedVideo,
    hasError,
    currentVideoRef
  } = useVideoLoader(currentVideo, dispatch);
  const {
    isPlaying
  } = usePlayerPolling(loadedVideo, currentVideo, currentVideoRef, dispatch);
  const handleClearVideo = useCallback(() => {
    dispatch(updatePlaybackState(createInitialPlaybackState()));
    dispatch(clearCurrentVideo());
  }, [dispatch]);

  const isVisible = useMemo(() => !easeInOut || Boolean(currentVideo) || hasError, [easeInOut, currentVideo, hasError]);

  const videoTitle = useMemo(() => (currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.description) || (currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.title), [currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.description, currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.title]);
  return React.createElement(VisibilityWrapper, {
    className: "pg_video_analysis_player",
    isVisible: isVisible
  }, hasError && React.createElement("div", {
    className: "pg_video_analysis_player__error_message"
  }, "Error loading video."), !hasError && loadedVideo && React.createElement("section", {
    "aria-label": "Videoanalys ".concat(videoTitle),
    className: clx('pg_video_analysis_player__video_details', {
      'pg_video_analysis_player__video_details--playing': isPlaying
    })
  }, React.createElement(VideoPlayer, {
    jsonLDTags: loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.jsonLDTags,
    src: loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.src,
    title: loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.title,
    videoId: loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.videoId
  }), React.createElement("div", {
    className: "pg_video_analysis_player__video_title"
  }, videoTitle), React.createElement(ReactIconButton, {
    "aria-label": "St\xE4ng videoanalys",
    className: "pg_video_analysis_player__clear_video_button no_print",
    onClick: handleClearVideo
  }, React.createElement(ReactIcon, {
    color: "icon",
    icon: "close",
    size: "300"
  }))));
};
setGlobal('svs.components.tipsen.videoAnalysisPlayer', {
  VideoAnalysisPlayer
});

 })(window);